<div>
  <app-table [res]="logs"(deleteItem)="deleteLog($event)"  />
</div>